export const SURVEY_REQUIRED_CODE = 'SURVEY_REQUIRED';
export const SURVEY_FLOW_CANCELLED_CODE = 'SURVEY_FLOW_CANCELLED';

export const normalizeSurveyRequirement = (payload) => {
  const surveyData = payload?.data?.requiresSurvey !== undefined ? payload.data : payload;

  if (!surveyData?.requiresSurvey) {
    return null;
  }

  return {
    ...surveyData,
    questions: [...(surveyData.questions || [])].sort((left, right) => (left?.sortOrder || 0) - (right?.sortOrder || 0)),
  };
};

export const getSurveyRequirementFromError = (error) => {
  if (error?.response?.status !== 409) {
    return null;
  }

  const responseData = error?.response?.data;
  const responseCode = responseData?.code || responseData?.data?.code;

  if (responseCode !== SURVEY_REQUIRED_CODE && !responseData?.data?.requiresSurvey) {
    return null;
  }

  return normalizeSurveyRequirement(responseData);
};

export const extractApiMessage = (error, fallbackMessage = 'Something went wrong. Please try again.') =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  fallbackMessage;

export const createSurveyFlowCancelledError = () => {
  const error = new Error('Survey flow cancelled');
  error.code = SURVEY_FLOW_CANCELLED_CODE;
  return error;
};

export const isSurveyFlowCancelledError = (error) => error?.code === SURVEY_FLOW_CANCELLED_CODE;

export const isDuplicateSurveySubmissionError = (error) => {
  const code = `${error?.response?.data?.code || error?.response?.data?.data?.code || ''}`.toLowerCase();
  const message = extractApiMessage(error, '').toLowerCase();

  return (
    code.includes('duplicate') ||
    code.includes('already_submitted') ||
    code.includes('alreadysubmitted') ||
    message.includes('duplicate') ||
    message.includes('already submitted')
  );
};

const normalizeValidationMessage = (value) => {
  if (Array.isArray(value)) {
    return value.join(' ');
  }

  if (typeof value === 'string') {
    return value;
  }

  return '';
};

export const extractSurveyValidationDetails = (error, questions = []) => {
  const rawErrors = error?.response?.data?.errors || error?.response?.data?.data?.errors;
  const fieldErrors = {};
  const questionIdsByIndex = questions.map((question) => question?.id);

  if (rawErrors && typeof rawErrors === 'object' && !Array.isArray(rawErrors)) {
    Object.entries(rawErrors).forEach(([fieldName, value]) => {
      const message = normalizeValidationMessage(value);
      const matchedIndex = fieldName.match(/answers\.(\d+)\./);

      if (matchedIndex) {
        const questionId = questionIdsByIndex[Number(matchedIndex[1])];
        if (questionId) {
          fieldErrors[questionId] = message;
        }
      }
    });
  }

  let formError = '';

  if (Array.isArray(rawErrors)) {
    formError = rawErrors.join(' ');
  } else if (typeof rawErrors === 'string') {
    formError = rawErrors;
  }

  if (!formError) {
    formError = extractApiMessage(error, '');
  }

  return { fieldErrors, formError };
};
